import { UserInfo } from '../../types/chatTypes'
import { axiosClient } from '../axiosClient'

export const userFunctions = {
  fetchUserInfo: async (): Promise<UserInfo> => {
    return await axiosClient.get('auth/user')
  },
}
